import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs';

import './AdminLandingCarousel.css'

const LANDING_CAROUSEL_URL = 'landing-carousel'

const ViewLandingCarousel = () => {
    const [landingCarousel, setLandingCarousel] = useState([])
    useEffect(() => {
        const getData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_DEPT_API}/${LANDING_CAROUSEL_URL}`)
                setLandingCarousel(response.data)
            } catch (err) {
                console.log(err)
                alert("Error, check console logs")
            }
        }
        getData()
        // eslint-disable-next-line
    }, [])

    const sortedLandingCarousel = landingCarousel && landingCarousel.sort((a, b) => a.order_no < b.order_no ? -1 : 1)

    return (
        <div className='admin'>
            <div className='section__container'>
                <div className='section'>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/admin" className='breadcrumb__link'>
                            Admin
                        </Link>
                        <Link to="" className='breadcrumb__link bold'>
                            Landing Carousal
                        </Link>
                    </Breadcrumbs>
                </div>
                <div className='section'>
                    <h3 className='section__header'>Landing Carousel</h3>
                    <Link to='add'>
                        <button className='admin_add_btn'>ADD</button>
                    </Link>
                    <div className='admin_facilities__container'>
                        {sortedLandingCarousel && sortedLandingCarousel.map(lc => (
                            <div key={lc._id} className='admin_facility_card'>
                                <h2>Title: {lc.title}</h2>
                                <p>Description: {lc.description}</p>
                                {lc.image && (
                                    <div className='admin_facility_img'>
                                        <p>Image :</p> 
                                        <img src={lc.image && lc.image.url} alt="Facility" style={{ width: "100px" }} />
                                    </div>
                                )}
                                <p>{lc.testimonial}</p>
                                <p>Order number: {lc.order_no}</p>
                                <div>
                                    <Link to={`${lc._id}/update`}>
                                        <button className='admin_btn'>Edit</button>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewLandingCarousel